import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { AttackEventOverviewBridge } from '../../../components/attack-event'

export interface AttackEventOverviewWrapperProps {
  readonly attackEventId: string
  readonly organizationID: string
}

function AttackEventOverviewWrapper({
  attackEventId,
  organizationID
}: AttackEventOverviewWrapperProps) {
  if (!attackEventId) {
    throw new Error('attackEventId is a required prop')
  }
  if (!organizationID) {
    throw new Error('organizationID is a required prop')
  }

  return (
    <AttackEventOverviewBridge
      attackEventID={attackEventId}
      organizationID={organizationID}
    />
  )
}

export const reactAttackEventOverview = createNgReactBridgeDirective(
  'reactAttackEventOverview',
  [],
  AttackEventOverviewWrapper,
  ['attackEventId', 'organizationID']
)
